export default __webpack_public_path__ + "static/media/ILUSTRACIONES_01.282960b2.png";